<template>
    <ViewCover style="height: 100%; overflow: hidden;">
        <ScrollHandler>
            <iframe key="iframe_doc" 
                frameborder="0"
                width="100%" height="98%" 
                ref="scroller"
                class="documentation" 
                src="https://wiki.carbis.ru/external/prodelivery"
            >
            </iframe>
        </ScrollHandler>
    </ViewCover>
</template>

<script>
import ViewCover from './ViewCover.vue';
import ScrollHandler from '@/components/scroller_handler'

export default{
    methods:{

    },
    components:{
        ViewCover,
        ScrollHandler
    }
}
</script>

<style>
.documentation{
    overflow: hidden;
}

::-webkit-scrollbar {
    display: none !important;
}
</style>